module.exports = __webpack_public_path__ + "img/niice.f44dbcfeb9fce51bd1e3cc3c76013f3f.svg";